import store from '@/store'

export default [
  {
    path: '/retail-sales',
    name: 'retail-sale',
    meta: { requiresAuth: true },
    component: () => import('@/pages/retail-sale/index.vue')
  },
  {
    path: '/retail-sales/create',
    name: 'retail-sale-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/retail-sale/create.vue')
  },
  {
    path: '/retail-sales/:id/edit',
    name: 'retail-sale-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/retail-sale/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('retailSale/find', to.params.id)
      next()
    }
  }
]
